/**
 * Delete keys from object that are undefined.
 * Firestore does not like to accept documents with undefined values.
 */
export function removeUndefined(x) {
    if (!x)
        return x;
    if (Array.isArray(x))
        return x.filter((v) => v !== undefined).map(removeUndefined);
    Object.keys(x).forEach((key) => x[key] === undefined
        ? delete x[key]
        : typeof x[key] === "object"
            ? (x[key] = removeUndefined(x[key]))
            : undefined);
    return x;
}
/**
 * Delete keys from object that are null
 */
export const removeNull = (x) => {
    const obj = Object.assign({}, x);
    Object.keys(obj).forEach((key) => obj[key] === null && delete obj[key]);
    return obj;
};
/**
 * Delete keys from object that are null and undefined
 */
export const removeUndefinedNull = (x) => {
    return removeUndefined(removeNull(x));
};
/**
 * Normalize string in field for querying.
 * Replaces certain special characters and removes duplicate spaces.
 */
export const normalizeValue = (s) => {
    return s
        ? s
            .replace(/[.@,/#!$%^&*;:{}=\-_`~()]/g, "")
            .replace(/^\s+|\s+$|\s+(?=\s)/g, "")
            .toLowerCase()
        : undefined;
};
//# sourceMappingURL=firestore-document.js.map